import { render, staticRenderFns } from "./AnonymousLayout.vue?vue&type=template&id=206eac44&"
import script from "./AnonymousLayout.vue?vue&type=script&lang=ts&"
export * from "./AnonymousLayout.vue?vue&type=script&lang=ts&"
import style0 from "./AnonymousLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports